<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-arrow-left mr-2" />Kirim Balik PGI</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Faktur">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.status" :options="optFilterStatus" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Office">
                        <b-form-select v-model="filter.office" :options="optFilterOffice" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group label="Tgl. Pembuatan Dari">
                        <b-form-input type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Tgl. Pembuatan Sampai">
                        <b-form-input type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data pengembalian barang.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    {{ row.item.inventory.no_faktur_pgi }}
                    <div class="small text-muted">
                        <strong>{{ row.item.inventory.imei_sn }}</strong>
                    </div>
                </template>
                <template v-slot:cell(inventory)="row">
                    {{ row.item.inventory.item_type.name }} <span v-if="row.item.inventory.year != null">({{ row.item.inventory.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.inventory.item_type.brand.kind.name }} - {{ row.item.inventory.item_type.brand.name }}
                    </div>
                </template>
                <template v-slot:cell(returnTo)="row">
                    Ke : {{ row.item.source }}<br />
                    Dari : {{ row.item.office }}
                </template>
                <template v-slot:cell(created)="row">
                    {{ $helper.parseDate(row.item.created_at) }}, {{ $helper.parseHourMinute(row.item.created_at) }}
                    <div class="small text-muted">
                        {{ row.item.request_note }}
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]" v-b-tooltip.hover.top
                        :title="row.item.status == 3 ? 'Menunggu pembayaran nasabah dikonfirmasi PGI. request baru bisa diproses setelah pembayaran dikonfirmasi.' : ''">
                        {{ getStatusBadge(row.item.status)[1] }}
                        <i v-if="row.item.status == 3" class="fa fa-info-circle ml-1" />
                    </b-badge>
                    <div class="small text-muted">
                        {{ getReturnReasonString(row.item.return_reason) }}
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div v-if="row.item.status == 0">
                        <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Kirim Balik" @click="acceptRequest(row.item)">
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="danger" v-b-tooltip.hover.top title="Tolak" @click="rejectRequest(row.item)">
                            <i class="fa fa-fw fa-times" />
                        </b-button>
                    </div>
                    <b-button v-else size="sm" variant="primary" v-b-tooltip.hover.top title="Info" @click="openInfo(row.item)">
                        <i class="fa fa-fw fa-info" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-reject" title="Tolak Request Kirim Balik" centered no-close-on-backdrop hide-footer>
            Menolak ajuan kirim balik untuk Nomor Faktur {{ activeItem.inventory.no_faktur_pgi }}.
            <b-form-group label="Alasan" class="mt-4">
                <b-input v-model="input.notes" maxlength="100" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execRejectRequest">
                    {{ isSubmitting ? "Menolak..." : "Tolak Pengajuan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-info" title="Informasi Kirim Balik" centered no-close-on-backdrop hide-footer>
            Informasi untuk NF <strong>{{ info.noFaktur }}</strong>
            <div class="mt-4">
                <div>
                    <strong>Request kirim balik pada</strong><br />
                    {{ $helper.parseDate(info.requestedAt) }}, {{ $helper.parseHourMinute(info.requestedAt) }}<br />
                    Catatan: {{ info.requestNote }}
                </div>
                <div class="mt-4">
                    <strong>Diproses oleh / pada</strong>
                    <div v-if="info.processedAt != null">
                        {{ $helper.parseDate(info.processedAt) }}, {{ $helper.parseHourMinute(info.processedAt) }}<br />
                        oleh <strong>{{ info.processedBy.fullname }}</strong>
                    </div>
                    <div v-else class="text-muted">
                        Belum diproses
                    </div>
                </div>
                <div v-if="info.rejectNote != null" class="mt-4">
                    <strong>Alasan Penolakan</strong><br />
                    {{ info.rejectNote }}
                </div>
                <div class="mt-4 font-weight-bold">Sampai di PGI pada</div>
                <div v-if="info.arrivedAt != null">
                    {{ $helper.parseDate(info.arrivedAt) }}, {{ $helper.parseHourMinute(info.arrivedAt) }}
                </div>
                <div v-else class="text-muted">
                    Belum sampai
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                noFaktur: "",
                status: -1,
                startDate: "",
                endDate: "",
                office: -1
            },

            input: {
                notes: ""
            },

            info: {
                noFaktur: "",
                requestedAt: null,
                requestNote: null,
                processedBy: null,
                processedAt: null,
                arrivedAt: null,
                rejectNote: null
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "noFaktur", label: "No. Faktur / IMEI", sortable: true },
                { key: "inventory", label: "Barang", sortable: true },
                { key: "returnTo", label: "Pengembalian", sortable: true },
                { key: "created", label: "Tgl. Request", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null,
                inventory: {}
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 3, text: "Menunggu Pembayaran" },
                { value: 0, text: "Pending" },
                { value: 1, text: "Dalam Pengiriman" },
                { value: 2, text: "Tiba di PGI" },
                { value: 9, text: "Ditolak" },
                { value: 10, text: "Batal"}
            ],

            optFilterOffice: [
                { value: -1, text: "Semua" }
            ],

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()
            let getOffices = this.$axios.get("master/offices").then(res => {
                for(let i = 0; i < res.data.data.length; i++){
                    this.optFilterOffice.push({value: res.data.data[i].id, text: res.data.data[i].name})
                }
            })

            Promise.all([getItems, getOffices]).then(() => {
                this.initStatus = 1
            })
            .catch(_ => {
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if(this.filter.office != -1) {
                param += "&filterOffice=" + this.filter.office
            }

            if(this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("inventory-return-pgi" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listKirimBalikFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        acceptRequest(item) {

            this.activeItem = item

            let isConfirmed = confirm(`Terima request kirim balik untuk faktur ${item.inventory.no_faktur_pgi}? Status akan diubah menjadi dalam pengiriman ke ${item.source}!`)
            if(!isConfirmed) return

            this.isSubmitting = true

            let payload = {
                id: this.activeItem.id,
                status: 1
            }

            this.$axios.post("inventory-return-pgi/process", payload).then(_ => {

                this.$helper.toastSuccess(this, "Request berhasil diterima!")
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        rejectRequest(item) {
            this.activeItem = item
            this.$bvModal.show("m-reject")
        },

        execRejectRequest() {

            if(this.$helper.isBlank(this.input.notes)) {
                return this.$helper.toastError(this, "Mohon mengisi alasan penolakan!")
            }

            let isConfirmed = confirm("Tolak ajuan ini?")
            if(!isConfirmed) return

            this.isSubmitting = true

            let payload = {
                id: this.activeItem.id,
                note: this.input.notes,
                status: 9
            }

            this.$axios.post("inventory-return-pgi/process", payload).then(_ => {

                this.$helper.toastSuccess(this, "Request berhasil ditolak!")
                this.$bvModal.hide("m-reject")
                this.input.notes = ""
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        openInfo(item) {

            this.info.noFaktur = item.inventory.no_faktur_pgi
            this.info.processedBy = item.processed_by
            this.info.processedAt = item.processed_at
            this.info.rejectNote = item.reject_note
            this.info.arrivedAt = item.arrived_at
            this.info.requestedAt = item.created_at
            this.info.requestNote = item.request_note

            this.$bvModal.show("m-info")

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getStatusBadge(status) {
            switch(status) {
                case 3: return ["secondary", "MENUNGGU PEMBAYARAN"]
                case 0: return ["warning", "PENDING"]
                case 1: return ["primary", "PENGIRIMAN"]
                case 2: return ["success", "TIBA DI PGI"]
                case 9: return ["danger", "DITOLAK"]
                case 10: return ["danger", "BATAL"]
                default: return ["light", "-"]
            }
        },

        getReturnReasonString(returnReason) {
            switch(returnReason) {
                case 0: return "Tidak Ada"
                case 1: return "Inventaris"
                case 2: return "Pergantian Barang"
                case 3: return "Prive Pak Andrew"
                case 4: return "Barang Tebusan"
                case 5: return "ICloud/Account"
            }
        }

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listKirimBalikFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listKirimBalikFilter"))
        }
        this.init()
    }
}
</script>
